export const moduleConstantes = Object.freeze({
  MODULE_STUDEA_DRIVER_LICENCE: "MODULE_STUDEA_DRIVER_LICENCE",
  MODULE_STUDEA_REGISTRATION: "MODULE_STUDEA_REGISTRATION",
});
